import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { tables: Array };
  observers = [];
  connect() {
    this.tables = this.tablesValue;
    this.tables.forEach((tableConfig) => {
      tableConfig.isDirty = false;
      // check if target exists
      if (this.element.querySelector(tableConfig.tableId) === null) {
        return;
      }
      this.setupTable(tableConfig);
      this.setupInputListeners(tableConfig);
    });
  }

  setupTable(tableConfig) {
    const table = this.element.querySelector(tableConfig.tableId);
    if (!table) {
      return;
    }

    const observer = new MutationObserver(mutations => {


      const correspondingConfig = this.tables.find((classTableConfigs) => classTableConfigs.tableId === tableConfig.tableId);
      correspondingConfig.isDirty = true
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });
    this.observers.push(observer);
  }

  setupInputListeners(tableConfig) {
    const inputs = this.element.querySelector(tableConfig.tableId).querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      input.addEventListener('input', () => {
        const correspondingConfig = this.tables.find((classTableConfigs) => classTableConfigs.tableId === tableConfig.tableId);
        correspondingConfig.isDirty = true
      });
    });
  }

  disconnect() {
    this.observers.forEach(observer => observer.disconnect());
  }

  submitForm(event) {
    event.preventDefault();
    const form = this.element;
    const formData = new FormData(form);
    const submitButton = event.submitter;
    if (submitButton && submitButton.name === "direction") {
      formData.append(submitButton.name, submitButton.value);
  } else {
      // Fallback: manually find the button if event.submitter isn't supported
      const buttons = form.querySelectorAll('button[type="submit"][name="direction"]');
      buttons.forEach(button => {
          if (document.activeElement === button) {
              formData.append(button.name, button.value);
          }
      });
  }
    this.tables.forEach(tableConfig => {
      if (!tableConfig.isDirty) {
        const keysToRemove = [];
        for (let key of formData.keys()) {
            if (key.startsWith(tableConfig.prefix)) {
                keysToRemove.push(key);
            }
        }
        // Remove all collected keys
        keysToRemove.forEach(key => formData.delete(key));
      }
    });

    this.submitFormData(formData);
  }

  submitFormData(formData) {
    const url = this.element.action;
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content
      },
      redirect: 'follow'
    }).
    then(response => window.location.href = response.url)
    .catch(error => {
      // Handle any error
    });
  }

}
